<div class="aws-dashboard-container">
    <iframe [src]="awsPublicUrl | safe: 'resourceUrl'"></iframe>
</div>
